const currencyFormater = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', })

function getCircularReplacer() {

    const seen = new WeakSet()

    return (key, value) => { // eslint-disable-line

        if (typeof value === "object" && value !== null) {

            if (seen.has(value)) return undefined

            seen.add(value)
        }

        return value
    }
}

const methods = {

    clipboard: (text) => { if (text) { navigator.clipboard.writeText(text) } },

    capitalize: (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase(),

    formatDate({ date, format }) {

        let value

        if (date instanceof Date) value = date
        else if (typeof date === 'number') value = new Date(date)

        else if (typeof date === 'string') {

            // dd/mm/yyyy o dd-mm-yyyy
            let m = date.match(/^(\d{2})[/-](\d{2})[/-](\d{4})$/)
            if (m) {
                const [_, dd, mm, yyyy] = m // eslint-disable-line
                value = new Date(Number(yyyy), Number(mm) - 1, Number(dd))
            }

            // yyyy/mm/dd
            if (!value) {
                m = date.match(/^(\d{4})\/(\d{2})\/(\d{2})$/)
                if (m) {
                    const [_, yyyy, mm, dd] = m // eslint-disable-line
                    value = new Date(Number(yyyy), Number(mm) - 1, Number(dd))
                }
            }

            // fallback
            if (!value) {
                const auto = new Date(date)
                if (!isNaN(auto)) value = auto
            }
        }

        if (!value || isNaN(value)) value = new Date()

        const pad2 = n => String(n).padStart(2, '0')

        if (format.includes('dd/mm/yyyy')) { format = format.replace('dd/mm/yyyy', '{day2}/{month2}/{year4}') }
        else if (format.includes('dd/mm/yy')) { format = format.replace('dd/mm/yy', '{day2}/{month2}/{year2}') }
        else if (format.includes('dd/mm')) { format = format.replace('dd/mm', '{day2}/{month2}') }

        if (format.includes('hh:mm:ss')) { format = format.replace('hh:mm:ss', '{hours2}:{minutes2}:{seconds2}') }
        else if (format.includes('hh:mm')) { format = format.replace('hh:mm', '{hours2}:{minutes2}') }

        const map = {

            day: value.getDate(), day2: pad2(value.getDate()),
            month: value.getMonth() + 1, month2: pad2(value.getMonth() + 1),
            monthName: methods.capitalize(new Intl.DateTimeFormat('es', { month: 'long' }).format(value)),
            monthNameShort: methods.capitalize(new Intl.DateTimeFormat('es', { month: 'short' }).format(value)),
            year: value.getFullYear(), year2: value.getFullYear() % 100, year4: value.getFullYear(),
            dayOfMonth: value.getDate(), dayOfMonth2: pad2(value.getDate()),
            dayOfWeek: value.getDay(),
            hours: value.getHours(), hours2: pad2(value.getHours()),
            minutes: value.getMinutes(), minutes2: pad2(value.getMinutes()),
            seconds: value.getSeconds(), seconds2: pad2(value.getSeconds()),
            milliseconds: value.getMilliseconds(),
            time: value.getTime(),
            iso: value.toISOString()
        }

        return format.replace(/\{(\w+)\}/g, (_, key) => map[key] ?? `{${key}}`)
    },

    sanitizeFilename: s => s.normalize("NFKC").split("").map(c=>c<' '?"_":c).join("").replace(/[<>:"/\\|?*]+/g,"_").replace(/[. ]+$/g,"").replace(/_{2,}/g,"_").trim(),

    download: (data) => {

        const extensionsMap = {

            'application/zip': '.zip',
            'application/pdf': '.pdf',
            'image/png': '.png',
            'image/jpeg': '.jpg',
            'text/plain': '.txt',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
            'application/json': '.json'
        }

        if (!data.url) {

            if (data.blob) { data.data = data.blob }
            if (data.arraybuffer) { /* Conversion */ }

            data.url = URL.createObjectURL(data.data)
        }

        if (!data.filename && data.url) { data.filename = data.url.split('/').reverse()[0] } // Build filename from url

        if (data.filename) {

            if (!data.extension) {

                const ext = extensionsMap[data.data?.type]

                if (ext && !data.filename.includes(ext)) data.extension = ext
            }

            if (data.extension) { data.filename += data.extension } // Add extension to filename
        }

        const a = document.createElement('a')
        a.setAttribute('href', data.url)
        a.setAttribute('download', data.filename)
        document.body.appendChild(a)
        a.click()
        a.parentNode.removeChild(a)

        URL.revokeObjectURL(data.url)
    },

    handleFocusGroup: (callback) => {

        const origin = document.activeElement
        const originFocusGroup = origin.getAttribute('focus-group')

        setTimeout(() => Array.from(document.querySelectorAll('*[focus-group]')).forEach(e => e.tabIndex = 0), 150)

        const inFocusGroup = (target) => {

            if (target === null) { callback(); return }

            let element = target

            // Iterate parent elements until reach group parent, if the focus remains in the group, the following element is monitored
            do {

                if (origin === element || (originFocusGroup && element.getAttribute('focus-group') === originFocusGroup)) { listenBlurEvent(target); return }
                element = element.parentElement

            } while (element)

            callback()
        }

        const listenBlurEvent = (target) => { target.addEventListener('blur', (e) => inFocusGroup(e.relatedTarget), { once: true }) }

        listenBlurEvent(origin)
    },

    animateNumber: (start, end, duration, target) => {

        if (end <= 3) duration = duration / 2

        const startTime = performance.now()
        const easeOutQuad = t => t * (2 - t)
        const isDOM = target instanceof Element

        const update = now => {
            const t = Math.min((now - startTime) / duration, 1)
            const eased = easeOutQuad(t)
            const value = start + (end - start) * eased

            if (isDOM) target.textContent = Math.floor(value)
            else if (typeof target === 'function') target(value)

            if (t < 1) requestAnimationFrame(update)
        }

        requestAnimationFrame(update)
    },

    isPlural: (data, first, second) => (isNaN(data) ? data.length : data) > 1 ? first : second,

    formatBytes: (bytes) => {

        if (!bytes) return

        const thresh = 1000; // Base 1000, sistema internacional

        if (Math.abs(bytes) < thresh) { return bytes + ' B' }

        const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        let u = -1;
        const r = 100; // Obtener dos decimales

        do {
            bytes /= thresh;
            ++u;
        } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


        return bytes.toFixed(2) + ' ' + units[u];
    },

    normalizeFilename: (filename) => filename.trim().replaceAll(/[/\\?%*:|"<> \t]+/g, '_').replaceAll(/_+/g, '_').slice(0, 255),

    formatTimer: (seconds) => {

        const secs = seconds % 60
        const mins = (seconds - secs) / 60

        return `${mins.toString().padStart(2, 0)}:${secs.toString().padStart(2, 0)}`
    },

    prettyMs(milliseconds) {

        const ms = milliseconds % 1000;
        let totalSeconds = Math.floor(milliseconds / 1000);
        const secs = totalSeconds % 60;
        totalSeconds = Math.floor(totalSeconds / 60);
        const mins = totalSeconds % 60;
        const hrs = Math.floor(totalSeconds / 60);

        const parts = [];
        if (hrs) parts.push(`${hrs}h`);
        if (mins) parts.push(`${mins}m`);
        if (secs) parts.push(`${secs}s`);
        if (!parts.length && ms) parts.push(`${ms}ms`);

        return parts.join(" ");
    },

    prettyTime: (miliseconds, justHrsMins) => {

        const ms = miliseconds % 1000
        miliseconds = (miliseconds - ms) / 1000
        const secs = miliseconds % 60
        miliseconds = (miliseconds - secs) / 60
        const mins = miliseconds % 60
        const hrs = (miliseconds - mins) / 60

        if (justHrsMins) { return `<span>${hrs}h</span> <span>${mins}m</span>` }

        if (hrs) { return `<span>${hrs}h</span> <span>${mins}m</span> <span>${secs}s</span>` }
        else if (mins) { return `<span>${mins}m</span> <span>${secs}s</span>` }
        else { return `<span>${secs > 1 ? secs : 1}s</span>` }
    },

    currencyNumberFormat: (value) => currencyFormater.format(value).trim(),

    getParameterCaseInsensitive: (object, key) => {

        if (!object || typeof object !== 'object') return undefined

        if (key in object) return object[key]

        return object[Object.keys(object).find(k => k.toLowerCase() === key.toLowerCase())]
    },

    horizontalDrag: (event, threshold = 6) => {

        const target = event.currentTarget
        const pos = { x: event.clientX }
        let dragAllowed = false

        const MouseMoveHandler = (e) => {

            const x = e.clientX

            if (!dragAllowed) {

                dragAllowed = Math.abs(x - pos.x) >= threshold
                return
            }

            const dx = x - pos.x
            pos.x = x
            target.scrollLeft = target.scrollLeft - dx

            document.body.style.cursor = 'grabbing'
            target.style.pointerEvents = 'none'
        }

        document.removeEventListener('mousemove', MouseMoveHandler)

        document.addEventListener('mousemove', MouseMoveHandler)

        document.addEventListener('mouseup', () => {

            document.removeEventListener('mousemove', MouseMoveHandler)
            document.body.style.cursor = 'auto'
            target.style.pointerEvents = 'auto'

        }, { once: true })
    },

    navigationUnderlineMenu: (container, current) => {

        if (!container) { return }

        let underline = container.querySelector('#underline')

        if (!underline) {

            container.classList.add('relative')
            underline = document.createElement('div')
            underline.id = 'underline'
            underline.classList.add('bg-current')
            underline.style.position = 'absolute'
            underline.style.bottom = '0'
            underline.style.height = '1px'
            underline.style.transition = 'width 200ms, left 200ms'
            container.appendChild(underline)
        }

        current = container.children[current]

        underline.style.width = current.clientWidth + 'px'
        underline.style.left = current.offsetLeft + 'px'
    },

    cancelableTimeout: (timeoutContext, timeoutRef, duration, callback) => {

        clearTimeout(timeoutContext[timeoutRef])

        if (duration && callback) { timeoutContext[timeoutRef] = setTimeout(callback, duration) }
    },

    clickWithoutDrag: (mousedownEvent, callback) => {

        if (!callback) return

        const target = mousedownEvent.currentTarget

        let originPos

        const cancel = () => {

            target.removeEventListener('mouseup', onClick)
            window.removeEventListener('mousemove', onMove)
        }

        const onClick = () => { callback(); cancel() }

        const onMove = (e) => {

            if (!originPos) {

                originPos = { x: e.x, y: e.y }
                return
            }

            if (Math.abs(e.x - originPos.x) > 10 || Math.abs(e.y - originPos.y) > 10) { cancel() }
        }

        target.addEventListener('mouseup', onClick, { once: true })
        window.addEventListener('mousemove', onMove)
    },

    safeStringify: obj => JSON.stringify(obj, getCircularReplacer()),

    objectToFormData: (obj, form = new FormData(), ns = '', opts = {}) => {

        const dateFormat = opts.date || 'iso'
        if (obj == null) return form
        for (const [k, v] of Object.entries(obj)) {
            const key = ns ? `${ns}[${k}]` : k
            if (v === undefined) continue
            if (v instanceof Blob || (typeof File !== 'undefined' && v instanceof File)) { form.append(key, v, v.name || 'file'); continue }
            if (v instanceof Date) { form.append(key, dateFormat === 'timestamp' ? String(+v) : dateFormat === 'string' ? String(v) : v.toISOString()); continue }
            if (Array.isArray(v)) { v.forEach((x, i) => methods.objectToFormData({ [i]: x }, form, key, opts)); continue }
            if (v && typeof v === 'object') { methods.objectToFormData(v, form, key, opts); continue }
            form.append(key, String(v))
        }
        return form
    },

    sanitizeHtml: html => (
        html
            ?.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '') // elimina <script>
            .replace(/<(iframe|object|embed|style|link|meta)[^>]*>[\s\S]*?<\/\1>/gi, '') // etiquetas peligrosas
            .replace(/\s*on\w+="[^"]*"/gi, '') // elimina onClick, onLoad, etc.
            .replace(/\s*on\w+='[^']*'/gi, '')
            .replace(/\s*on\w+=\S+/gi, '')
            .replace(/\s(href|src)\s*=\s*(['"])?(javascript|data):[^'"]*\2/gi, '') // bloquea javascript:
            .replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, (m, t) =>
                /^(b|strong|i|em|u|br|p|div|span)$/i.test(t) ? m : ''
            ) // solo deja etiquetas seguras
            .replace(/<([a-z][a-z0-9]*)\s+([^>]+)>/gi, (m, t, a) => {
                const c = a.match(/\bclass\s*=\s*(['"])[^'"]*\1/i);
                return c ? `<${t} ${c[0]}>` : `<${t}>`;
            }) || ''),

}

export default methods